import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://cnsbzvcoxgsbkkbpmqvg.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNuc2J6dmNveGdzYmtrYnBtcXZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5OTU4MzUsImV4cCI6MjA4NjU3MTgzNX0.1TiydYHF932So9u0bd0UDtFb-iDZRTV-yCIquxXuHHk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);